import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RadioProvider } from "@/context/RadioContext";
import { Navbar, Footer } from "@/components/fo/Navbar";
import { RadioPlayer } from "@/components/fo/RadioPlayer";
import { ScrollProgress, useAutoReveal } from "@/components/fo/Motion";
import Home from "@/pages/Home";
import RadioPage from "@/pages/Radio";
import Artists from "@/pages/Artists";
import ArtistPage from "@/pages/ArtistPage";
import Charts from "@/pages/Charts";
import { Blog, Article } from "@/pages/Blog";
import Pricing from "@/pages/Pricing";
import Join from "@/pages/Join";
import { Login, Register } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Weekly from "@/pages/Weekly";
import Battle from "@/pages/Battle";
import Contact from "@/pages/Contact";
import { Privacy, Terms, Cookies, CookieBanner } from "@/pages/Legal";
import { Forgot, Reset } from "@/pages/Auth";

const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useAutoReveal(pathname, !/^\/(admin|dashboard)/.test(pathname));
  return (
    <div className="min-h-screen overflow-x-hidden">
      <ScrollProgress />
      <Navbar />
      <main key={pathname} className="page-enter"><Outlet /></main>
      <Footer />
      <RadioPlayer />
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <RadioProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/radio" element={<RadioPage />} />
              <Route path="/artists" element={<Artists />} />
              <Route path="/a/:slug" element={<ArtistPage />} />
              <Route path="/charts" element={<Charts />} />
              <Route path="/weekly" element={<Weekly />} />
              <Route path="/battle" element={<Battle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/forgot-password" element={<Forgot />} />
              <Route path="/reset-password" element={<Reset />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Article />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/join" element={<Join />} />
              <Route path="/join/:slug" element={<Join />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </RadioProvider>
    </AuthProvider>
  );
}

export default App;
